export default __webpack_public_path__ + "static/media/error.5c323929.svg";